module.exports = __webpack_public_path__ + "static/cover-7b662c7b3474c823348e726840c8a127.png";